import React from 'react';
import {
  Image,
  Box,
  Text
} from '@chakra-ui/react';


import HeroWithRightMedia from '../../components/sections/herowithrightmedia';

import EVPMountainHardwear from '../../components/ui/ourcompany/leadership/TROY_SICOTTE_MHW_HEADSHOT-scaled.jpeg'
export default function MountainHardwearTabPanel() {
  return (
    <Box>
      <HeroWithRightMedia
        title={
          <Box>
            <Text fontWeight={'bold'} mt="10px">
              TROY SICOTTE
            </Text>
            <Text fontWeight={'bold'} fontSize="md" mb="8">
              PRESIDENT, MOUNTAIN HARDWEAR
            </Text>
            <Text fontSize="xs" mb="4">
              Troy Sicotte joined Mountain Hardwear in 2018 as Vice President of
              Sales and was named President of the Mountain Hardwear brand in
              September 2021. Prior to joining Mountain Hardwear, Mr. Sicotte
              served as Global Director of Sales at 034Motorsport. He held
              several leadership roles at The North Face, including Director of
              Sales: Footwear and Director of Sales: National Outdoor & Sporting
              Goods, and began his career at Birkenstock.
            </Text>
          </Box>
        }
        media={
          <Image
            width="500"
            height="441"
            borderRadius={10}
            src={EVPMountainHardwear}
          />
        }
      />
    </Box>
  );
}
